import 'slick-slider';
const slider404 = () => {
	// Slider news reel for the 404 of the page
	const bottomSlider = document.getElementsByClassName('bottom-parent');
	if (bottomSlider.length > 0) {
		$('.bottom-parent').slick({
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			arrows: true,
			centerMode: true,
			prevArrow: $('.bottom-parent__prev'),
			nextArrow: $('.bottom-parent__next'),
		});
	}
};

export default slider404;
